define([
    'text!./templates/mfp-show-coverages.html',
], templateStr => ['MFPService', function (MFPService) {

    const DEFAULT_TITLE_CLASS = 'mfp-show-coverages-title';
    const DEFAULT_COVERAGE_CLASS = 'mfp-show-coverages-coverage';

    return {
        restrict: 'E',
        scope: {
            title: '=?',
            coverages: '&',
            titleClass: '@?',
            coverageClass: '@?',
        },
        template: templateStr,
        link: function ($scope) {
            $scope.getFormattedCoverageTerms = getFormattedCoverageTerms;
            $scope.hasCoverageTerms = hasCoverageTerms;
            $scope.titleClass = $scope.titleClass || DEFAULT_TITLE_CLASS;
            $scope.coverageClass = $scope.coverageClass || DEFAULT_COVERAGE_CLASS;

            $scope.getCollapsed = function () {
                return $scope.$parent.$parent.$parent.collapsed; //Angular Standard way is not nicely readable therefore this solution
            };

        },
    };

    function getFormattedCoverageTerms(coverage) {
        const justVisibleCoverageTerms = [];

        coverage.terms.forEach((term) => {
            if (term.isVisibleInOverview) {
                justVisibleCoverageTerms.push(term);
            }
        });


        const formattedCoverageTerms = justVisibleCoverageTerms
            .map(term => MFPService.formatCoverageTerm(term, ' '));
        return formattedCoverageTerms;
    }

    function hasCoverageTerms(coverage) {
        if (coverage.terms.length > 0) {
            return true;
        }
        return false;
    }

}]);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPShowCoverages.js